module.exports = __webpack_public_path__ + "img/eronet.bc8f60f3.png";